import { type HTMLAttributes, forwardRef } from 'react'

/**
 * Plain card surface — soft shadow, rounded corners, brand-neutral
 * background. The dashboard composes these for every planning row.
 *
 * Cards are interactive when given an `onClick` (or rendered as a
 * `button` via `asButton`). The whole card becomes the touch
 * target then, with the same 48px minimum.
 */

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** When true, render the card as a clickable container. */
  interactive?: boolean
}

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { interactive = false, className, children, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={[
        'bg-surface rounded-2xl border border-surface-border',
        'shadow-sm',
        interactive
          ? 'transition-transform duration-100 active:scale-[0.99] cursor-pointer'
          : '',
        className ?? '',
      ].join(' ')}
      {...rest}
    >
      {children}
    </div>
  )
})
